// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"tU-z","inlineTitle":"uU-z","sponsoredAdsWrapper":"vU-z","marketplaceRecosWrapper":"wU-z"};